export enum ExtAppRouteEnum {
    aida = '/aida',
}
